import { DeployLayout } from "@/components/flow/deploy/Layout";
import { DeploySidebarContent } from "@/components/flow/deploy/Steps/Deploy/SidebarContent";
import { DeployVisualAreaContent } from "@/components/flow/deploy/Steps/Deploy/VisualAreaContent";
import { DeploySteps } from "@/types/flows";
import { useFlowState } from "@/hooks/useFlowState";

export const WorkflowPage = () => {
    const { step } = useFlowState();

    switch (step) {
        case DeploySteps.DEPLOY:
            return (
                <DeployLayout
                    Sidebar={<DeploySidebarContent />}
                    VisualArea={<DeployVisualAreaContent />}
                />
            );
        default:
            throw new Error(`Invalid step: ${step}`);
    }
};
